import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APIURL } from '../../../config'
import IconButton from "@mui/material/IconButton";
import Modal from '@mui/material/Modal';
import NoteFormv2 from '../../../components/forms/NoteForm/NoteFormv2'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';

const NewNote = (props) => {
    const [isNoteDirty, setIsNoteDirty] = useState(false);
    const [showExitConfirm, setShowExitConfirm] = useState(false);

    const handleFormClose = () => {
        if (isNoteDirty) {
            setShowExitConfirm(true);
        } else {
            props.setShowAddNote(false);
            props.setNoteCustomerID();
        }
    };

    const handleDiscard = () => {
        setIsNoteDirty(false);
        setShowExitConfirm(false);
        props.setShowAddNote(false);
        props.setNoteCustomerID();
    };

    const handleCancelDiscard = () => setShowExitConfirm(false);

    return (
        <>
            <Dialog fullWidth maxWidth="lg" open={props.showAddNote}>
                <DialogActions>
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={handleFormClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogActions>
                <DialogContent sx={{ paddingTop: '0px' }}>
                    <NoteFormv2
                        company_id={props.company_id}
                        mode='add'
                        checkTokenExpiry={props.checkTokenExpiry}
                        user={props.user}
                        customer_id={props.customer_id}
                        onSubmit={() => { props.setShowAddNote(false); setIsNoteDirty(false); }}
                        onDirtyChange={setIsNoteDirty}
                    />
                </DialogContent>
            </Dialog>
            {/* confirmation modal for unsaved changes */}
            <Dialog open={showExitConfirm} onClose={handleCancelDiscard}>
                <DialogTitle>Discard Changes?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You have unsaved changes. Are you sure you want to discard them?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDiscard}>Cancel</Button>
                    <Button onClick={handleDiscard} color='primary'>Discard</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default NewNote